import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "./Header";
import Footer from "./Footer";
import config from "../../config";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";

const Create_product = () => {
    let userDetail = localStorage.getItem("ship_rocket_user");
    let userData = userDetail ? JSON.parse(userDetail) : {};
  const [formData, setFormData] = useState({
    sku_id: "",
    product_name: "",
    price: "",
    weight: "",
    height: "",
    width: "",
    length: "",
    image: null,
  });
  const [previewImage, setPreviewImage] = useState("https://coffective.com/wp-content/uploads/2018/06/default-featured-image.png.jpg");
  const [productId, setProductId] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  // Extract product_id from URL if present
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("product_id");
    console.log("id --", id)
    if (id) {
      setProductId(id);
      fetchProduct(id);
    }
  }, [location.search]);

  const fetchProduct = async (id) => {
    try {
        let url = config.apiUrl + "/user/getProductById";
        let dataToSend = {customer_id:userData.customer_id , product_id:id}
       
      const res = await axios.post(url, dataToSend, { headers: config.headers });
      const data = res.data?.product;
      if (data) {
        setFormData({
          sku_id: data.sku_id,
          product_name: data.product_name,
          price: data.price,
          weight: data.weight,
          height: data.height,
          width: data.width,
          length: data.length,
          image: null,
        });
        setPreviewImage(data.image_url || "https://coffective.com/wp-content/uploads/2018/06/default-featured-image.png.jpg");
      }
    } catch (err) {
      Swal.fire("Failed to fetch product data", "", "error");
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, image: file }));
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const {
      sku_id,
      product_name,
      price,
      weight,
      height,
      width,
      length,
      image,
    } = formData;

    if (!sku_id || !product_name || !price || !weight || !height || !width || !length || (!image && !productId)) {
      return Swal.fire("All fields are required", "", "warning");
    }

    const form = new FormData();
    form.append("customer_id", userData.customer_id);
    form.append("sku_id", sku_id);
    form.append("product_name", product_name);
    form.append("price", price);
    form.append("weight", weight);
    form.append("height", height);
    form.append("width", width);
    form.append("length", length);
    if (image) form.append("image", image);
    if (productId) form.append("product_id", productId);

    try {
        let url = config.apiUrl + "/user/createOrUpdate";
       
      const res = await axios.post(`${config.apiUrl}/user/createOrUpdate`, form , { headers: config.headers });
      if (res.data?.message) {
        Swal.fire("Product saved successfully", "", "success");
        navigate("/manage_product");
      }
    } catch (error) {
      Swal.fire("Failed to save product", error?.response?.data?.message || error.message, "error");
    }
  };

  return (
    <div>
      <Header />
      <div className="page-wrapper pinned">
        <div className="main-container">
          <div className="app-container">
            <div className="app-body">
              <div className="container-fluid">
                <div className="mob_nav">
                  <div className=" d-flex justify-content-start ">
                    <a href="javascript:window.history.back();" className=""><i className="bi bi-arrow-left"></i></a>
                    <h2>{productId ? "Edit Product" : "Add Product"}</h2>
                  </div>
                </div>

                <div className="row justify-content-between">
                  <div className="col-12 col-md-4 desk_nav">
                    <div className="d-flex">
                      <a href="javascript:window.history.back();" className="back_btn"><i className="bi bi-arrow-90deg-left"></i></a>
                      <h2>{productId ? "Edit Product" : "Add Product"}</h2>
                    </div>
                  </div>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="card border-0 shadow-sm">
                    <div className="card-body p-4">
                      <div className="row g-5">
                        <div className="col-12 col-lg-4">
                          <div className="d-flex flex-column gap-3">
                            <div className="border rounded-3 p-3 text-center bg-light" style={{ minHeight: "320px", maxHeight: "320px" }}>
                              <img src={previewImage} className=" rounded-2" height="150px" alt="Product preview" id="productImagePreview" />
                            </div>
                            <div>
                              <div className="form-file">
                                <input type="file" className="form-control" id="productImage" onChange={handleImageChange} />
                                <label className="form-file-label text-muted small" htmlFor="productImage">
                                  {/* <span className="form-file-text">Upload or change product image</span> */}
                                  {/* <span className="form-file-button">Browse</span> */}
                                </label>
                              </div>
                              <div className="form-text small">JPEG, PNG or GIF (Max. 2MB)</div>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-lg-8">
                          <div className="row g-3">
                            {["sku_id", "product_name", "price", "weight", "height", "width", "length"].map((field, index) => {
                              const labels = {
                                sku_id: "SKU ID",
                                product_name: "Product name",
                                price: "Price (INR)",
                                weight: "Dead Weight including Packaging (KG)",
                                height: "Package Height (cm)",
                                width: "Package Width (cm)",
                                length: "Package Length (cm)",
                              };
                              const isTextField = field === "sku_id" || field === "product_name";
                              const inputType = isTextField ? "text" : "number";
                              return (
                                <React.Fragment key={index}>
                                  <div className="col-12 col-lg-4 d-flex align-items-center">
                                    <label htmlFor={field} className="form-label mb-0 fw-medium">{labels[field]}</label>
                                  </div>
                                  <div className="col-12 col-lg-8">
                                    <div className="input-group">
                                      {field === "price" && <span className="input-group-text">₹</span>}
                                      <input
                                         type={inputType}
                                        className="form-control form-control-lg"
                                        id={field}
                                        placeholder=""
                                        value={formData[field]}
                                        onChange={handleChange}
                                      />
                                      {(field === "weight" || field === "height" || field === "width" || field === "length") && (
                                        <span className="input-group-text">{field === "weight" ? "kg" : "cm"}</span>
                                      )}
                                    </div>
                                  </div>
                                </React.Fragment>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                      <div className="mt-4 pt-2 text-muted small">
                        <i className="bi bi-info-circle me-2"></i> This product image will be displayed to your buyer along with delivery updates sent via WhatsApp.
                      </div>
                      <div className="text-center my-3">
                        <button type="submit" className="btn btn-primary">{productId ? "Update Product" : "Save Product"}</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Create_product;
